import type { DatosUniverso } from '../modelo/tipos';

export interface ResultadoBusqueda {
  etiqueta: string;
  modulo: string;
  ruta: string;
}

/** Búsqueda sin IA: compara títulos y textos, sin distinguir mayúsculas. */
export function buscar(datos: DatosUniverso, consulta: string): ResultadoBusqueda[] {
  const q = consulta.trim().toLowerCase();
  if (!q) return [];
  const contiene = (t: string) => t.toLowerCase().includes(q);
  const r: ResultadoBusqueda[] = [];
  datos.suenos.forEach((d) => { if (contiene(d.titulo) || contiene(d.relato)) r.push({ etiqueta: d.titulo, modulo: 'Sueño', ruta: '/suenos/' + d.id }); });
  datos.notas.forEach((n) => { if (contiene(n.texto)) r.push({ etiqueta: n.texto, modulo: 'Nota', ruta: '/notas' }); });
  datos.biblioteca.forEach((b) => { if (contiene(b.titulo) || contiene(b.autor)) r.push({ etiqueta: b.titulo, modulo: 'Biblioteca', ruta: '/biblioteca/' + b.id }); });
  datos.actividades.forEach((c) => { if (contiene(c.titulo)) r.push({ etiqueta: c.titulo, modulo: 'Ejercicio', ruta: '/cursos/' + c.id }); });
  datos.bandeja.forEach((i) => { if (contiene(i.texto)) r.push({ etiqueta: i.texto, modulo: 'Bandeja', ruta: '/bandeja' }); });
  datos.libre.forEach((f) => { if (contiene(f.titulo)) r.push({ etiqueta: f.titulo, modulo: 'Espacio libre', ruta: '/libre' }); });
  return r;
}
